/**
 * Statsig feature gate per Guest Journey tab, keyed by the tab's route path.
 *
 * A tab's bar button (guest-journey.component) and its route
 * (main-routes → pruneRoutes) are both shown only when the gate is on, so this
 * map is the single source of truth for the two halves. Keep the values in sync
 * with the gates created in Statsig (naming convention `guest-journey-tab-*`).
 */
export const GUEST_JOURNEY_TAB_GATES = {
  'active-customers': 'guest-journey-tab-active',
  sliders: 'guest-journey-tab-sliding',
  churned: 'guest-journey-tab-churn',
  details: 'guest-journey-tab-details',
  'stage-movement': 'guest-journey-tab-stage-movement',
  'offer-impact': 'guest-journey-tab-offer-impact',
  retention: 'guest-journey-tab-retention',
  benchmarks: 'guest-journey-tab-benchmarks',
} as const;
